import { get } from "lodash";
import useWebInstance from "grandus-lib/hooks/useWebInstance";

import Image from "grandus-lib/components-atomic/image/Image";
import LoginForm from "components/forms/Login";
import RegisterForm from "components/forms/Register";

import styles from "components/blog/lockedMessage/LockedMessage.module.scss";
import { Button, Card } from "antd";
import { useState } from "react";

const authSectionContentList = {
  login: <LoginForm showRegister={false} afterLoginCallback={() => window.location.reload()} />,
  register: <RegisterForm afterRegisterCallback={() => window.location.reload()} />,
};

const LockedMessage = () => {
  const { webInstance } = useWebInstance();
  const [authSectionVisible, toggleAuthSection] = useState(false);
  const [authSectionActiveTab, toggleAuthSectionActiveTab] = useState(
    "login"
  );
  return (
    <>
      <section className={styles.lockedMessageFader}></section>
      <section className={styles?.lockedMessageLock}>
        <h4>
          <Image
            photo={get(webInstance, "logo")}
            size={`${get(webInstance, "logo.id")}/80x30`}
            type={"png"}
          />
          Článok pre registrovaných používateľov
        </h4>

        <p>
          Prihlásením/registráciou získate prístup ku všetkým článkom na našom
          webe a mnoho ďalších výhod.
        </p>

        {authSectionVisible ? (
          <Card
            style={{ width: "100%" }}
            bordered={false}
            tabList={[
              {
                key: "login",
                tab: "Prihlásenie",
              },
              {
                key: "register",
                tab: "Registrácia",
              },
            ]}
            activeTabKey={authSectionActiveTab}
            onTabChange={(key) => {
              toggleAuthSectionActiveTab(key);
            }}
          >
            {authSectionContentList[authSectionActiveTab]}
          </Card>
        ) : (
          <Button
            href="#"
            onClick={(e) => {
              e.preventDefault();
              toggleAuthSection(!authSectionVisible);
            }}
          >
            Prihláste sa/Registrujte sa
          </Button>
        )}
      </section>
    </>
  );
};

export default LockedMessage;